import { useEffect, useState } from "react";
import type { CallOutReasonCode } from "../../../api/staffApi";

const REASONS: { value: CallOutReasonCode; label: string }[] = [
  { value: "sick", label: "Sick" },
  { value: "family_emergency", label: "Family emergency" },
  { value: "transportation_issue", label: "Transportation" },
  { value: "schedule_conflict", label: "Schedule conflict" },
  { value: "other", label: "Other" },
];

type CallOutSheetProps = {
  open: boolean;
  busy?: boolean;
  onSubmit: (payload: { reasonCode: CallOutReasonCode; reasonNote?: string }) => void;
  onClose: () => void;
};

export function CallOutSheet({ open, busy, onSubmit, onClose }: CallOutSheetProps) {
  const [reasonCode, setReasonCode] = useState<CallOutReasonCode>("sick");
  const [note, setNote] = useState("");

  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="staff-sheet-backdrop" role="presentation" onClick={onClose}>
      <div className="staff-sheet staff-sheet--tall" role="dialog" aria-modal="true" onClick={(e) => e.stopPropagation()}>
        <h2 className="staff-sheet__title">Call out of shift</h2>
        <p className="muted staff-sheet__message">Management will be notified and the shift may reopen for others.</p>
        <label className="staff-field">
          <span>Reason</span>
          <select value={reasonCode} onChange={(e) => setReasonCode(e.target.value as CallOutReasonCode)}>
            {REASONS.map((r) => (
              <option key={r.value} value={r.value}>{r.label}</option>
            ))}
          </select>
        </label>
        <label className="staff-field">
          <span>Note (optional)</span>
          <textarea
            rows={3}
            value={note}
            onChange={(e) => setNote(e.target.value)}
            placeholder="Anything else we should know?"
          />
        </label>
        <div className="staff-sheet__actions">
          <button type="button" className="secondary-button" onClick={onClose} disabled={busy}>
            Cancel
          </button>
          <button
            type="button"
            className="staff-button staff-button--danger"
            disabled={busy}
            onClick={() => onSubmit({ reasonCode, reasonNote: note.trim() || undefined })}
          >
            {busy ? "Submitting…" : "Submit call-out"}
          </button>
        </div>
      </div>
    </div>
  );
}
